import { api } from './client';

/** Matches services.RecycledTab JSON from GET /recycling/tabs */
export interface ApiRecycledTab {
  id: string;
  original_id: string;
  url: string;
  title: string;
  closed_at: string;
  expires_at: string;
  session_id: string;
  context?: Record<string, unknown>;
  form_data?: Record<string, string>;
  scroll_pos?: { x: number; y: number };
}

/** Matches services.RestoredTab from POST /recycling/tabs/:id/restore */
export interface RestoredTab {
  url: string;
  title: string;
  session_id?: string;
  original_id?: string;
  tab_id?: string;
  context?: Record<string, unknown>;
  form_data?: Record<string, string>;
  scroll_pos?: { x: number; y: number };
  was_recycled: boolean;
}

export const tabRecyclingService = {
  async listRecycledTabs(): Promise<ApiRecycledTab[]> {
    const response = await api.get<{ tabs: ApiRecycledTab[] }>('/recycling/tabs');
    return response.data.tabs ?? [];
  },

  async restoreRecycledTab(id: string): Promise<RestoredTab> {
    const response = await api.post<RestoredTab>(`/recycling/tabs/${encodeURIComponent(id)}/restore`);
    return response.data;
  },

  async permanentlyDeleteRecycledTab(id: string): Promise<void> {
    await api.delete(`/recycling/tabs/${encodeURIComponent(id)}`);
  },

  async emptyRecyclingBin(): Promise<void> {
    await api.delete('/recycling/empty');
  },
};
